import { useEffect } from 'react';

const handleTabFeaturesItemClick = (event) => {
  const item = event.currentTarget;
  const { tabIndex } = item;
  const activeItem = item
    .closest('.tab-features')
    .querySelector('.tab-features-items__item_active');

  const images = item.closest('.tab-features').querySelectorAll('.tab-features-images__item');
  const activeItemImage = item
    .closest('.tab-features')
    .querySelector('.tab-features-images__item_active');

  if (item !== activeItem) {
    activeItem.classList.remove('tab-features-items__item_active');
    item.classList.add('tab-features-items__item_active');

    images.forEach((image) => {
      if (tabIndex === image.tabIndex) {
        activeItemImage.classList.remove('tab-features-images__item_active');
        image.classList.add('tab-features-images__item_active');
      }
    });
  }
};

export default function useTabFeatures() {
  useEffect(() => {
    const tabFeaturesItems = document.querySelectorAll('.tab-features-items__item');
    tabFeaturesItems.forEach((item) => item.addEventListener('click', handleTabFeaturesItemClick));

    return () =>
      tabFeaturesItems.forEach((item) =>
        item.removeEventListener('click', handleTabFeaturesItemClick)
      );
  }, []);
}
